import './ProductPanel.css';
import ReserveButton from '../ReserveButton/ReserveButton';
import Gallery from '../Gallery/Gallery';
function ProductPanel({ product, checkHumanity, productStats, hasInventory, hasLaunched }) {
  const { price, bundleName, bundleIncludes, bundleDesc, type, pricePerUnit,
    imgPath, images=null, productSet = false, mediaIPFS=null , qty=null} = product;
  let productState = "available";
  let disabledtext = null
  if (!hasLaunched) {
    productState = "prelaunch";
    disabledtext = "Coming Soon!";
  }
  else if (!hasInventory(type, qty)) {
    productState = "soldOut";
    disabledtext = "Sold Out!";
  }

  if (productSet) {
    return (
      <div id="product-panel" className="column is-12 is-12 is-flex is-relative">
        <div className="box is-flex is-flex-direction-column is-flex-grow-1">
          {imgPath && <img className="preview-img" alt={bundleName} src={imgPath} />}

          <div className="panel-content is-flex is-flex-direction-column is-flex-grow-1">
            <p className="price has-text-primary has-text-centered title is-4">₳ {price}</p>
            <p className="product-name title is-4 has-text-centered">{bundleName}</p>
            <Gallery images={images} imgWidth="80px" imgHeight="104px"/>
            <p className="product-desc has-text-centered">{bundleDesc}</p>
            {bundleIncludes &&
              <div className="pb-3">
                <p className="product-details mb-0"><b>Details:</b></p>
                {bundleIncludes.map((feature, i) => <p className="product-details mb-0" key={i}>{feature}</p>)}
              </div>

            }
            <div className="product-set-button is-align-self-center">
            <ReserveButton
              disabled={productState !== 'available'}
              action={checkHumanity}
              subject={product}
              text="Buy Now!"
              disabledText={disabledtext}
            />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div id="product-panel" className="column is-one-quarter-widescreen is-5-tablet is-flex is-relative">
      <div className="box is-flex is-flex-direction-column">
        {/* https://codepen.io/ArnaudBalland/pen/vGZKLr inspired overlay effect */}
        {imgPath &&
            <a 
              className="preview-img-link is-relative" 
              href={`https://ipfs.io/ipfs/${mediaIPFS}`}
              target="_blank"
              rel="noreferrer">
              <img className="preview-img" loading="lazy" alt={bundleName} src={imgPath} />
              <div className="preview-img-overlay"></div>
              <div className="overlay-content">
                <i className="play-icon fas fa-play"></i>
              </div>
            </a>
          }

          {/* {imgPath && 
          
          <img className="preview-img" loading="lazy" alt={bundleName} src={imgPath} />
          
          } */}

        <div className="panel-content is-flex is-flex-direction-column is-flex-grow-1">
          <p className="product-name title is-4 has-text-centered">{bundleName}</p>
          <p className="price-per-unit has-text-primary has-text-centered title is-4">₳ {pricePerUnit} per token</p>
          <p className="price has-text-primary has-text-centered title is-4">₳ {price} per bundle</p>
          <p className="product-desc has-text-centered">{bundleDesc}</p>
          {bundleIncludes &&
            <div className="pb-3">
              <p className="product-details mb-0"><b>Details:</b></p>
              {bundleIncludes.map((feature, i) => <p className="product-details mb-0" key={i}>{feature}</p>)}
            </div>

          }
          <ReserveButton
            disabled={productState !== 'available'}
            action={checkHumanity}
            subject={product}
            text={`Buy ${qty > 1 ? `${qty} ` : ''}Now!`}
            disabledText={disabledtext}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductPanel;